import { chakra } from "@chakra-ui/react";

export default function MyFees() {
  return <chakra.div>My Fees</chakra.div>;
}
